module.exports = __webpack_public_path__ + "static/img/db-life-smart-phone-sales-thumb.85ad20a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/db-life-smart-phone-sales-thumb.jpg
// module id = cx05
// module chunks = 0